import { render, staticRenderFns } from "./GeneralRules.vue?vue&type=template&id=242fa101&scoped=true&"
import script from "./GeneralRules.vue?vue&type=script&lang=js&"
export * from "./GeneralRules.vue?vue&type=script&lang=js&"
import style0 from "./GeneralRules.vue?vue&type=style&index=0&id=242fa101&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242fa101",
  null
  
)

export default component.exports